export const categoryFromDatabase = {

    'Placas de Vídeo': 'GPUs',
    'Placa de Vídeo': 'GPUs',
    'GPUs': 'Placa de Vídeo',

    'Processadores': 'CPUs',
    'Processador': 'CPUs',
    'CPUs': 'Processador',

    'Memórias RAM': 'RAMs',
    'Memória RAM': 'RAMs',
    'RAMs': 'Memória RAM',

    'Coolers': 'CPUCoolers',
    'Cooler': 'CPUCoolers',
    'CPUCoolers': 'Cooler',

    'Placas-Mãe': 'Motherboards',
    'Placa-Mãe': 'Motherboards',
    'Motherboards': 'Placa-Mãe',

    'Fontes': 'PowerSupplys',
    'Fonte': 'PowerSupplys',
    'PowerSupplys': 'Fonte',

    'Gabinetes': 'Cases',
    'Gabinete': 'Cases',
    'Cases': 'Gabinete',

    'Armazenamentos': 'Storages',
    'Armazenamento': 'Storages',
    'Storages': 'Armazenamento',
    
}